<template>
  <div class="dynamic-content-wrapper">
    <div v-if="uiFlags.isFetching" class="loader">
      <spinner />
    </div>
    <div
      v-else-if="content"
      class="column content-box changelog-wrapper overflow-auto"
      v-html="content"
    />
    <slot v-else name="fallback" />
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner
  },
  props: {
    descriptionKey: undefined,
    locale: {
      type: String,
      default: undefined,
    },
  },
  mounted() {
    this.refresh();
  },
  watch: {
    descriptionKey() {
      this.refresh()
    },
    locale() {
      this.refresh();
    },
  },
  computed: {
    ...mapGetters({
      getDescription: 'online99Extra/getDescription',
      uiFlags: 'online99Extra/getUIFlags',
    }),
    cacheKey() {
      return this.locale
        ? `${this.descriptionKey}::${this.locale}`
        : this.descriptionKey;
    },
    content() {
      return this.getDescription(this.cacheKey)?.content;
    },
  },
  methods: {
    refresh() {
      this.$store.dispatch('online99Extra/show', {
        id: this.descriptionKey,
        locale: this.locale,
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.dynamic-content-wrapper {
  display: contents; // let the children participate in the parent's layout directly
}

.changelog-wrapper {
  font-size: medium;
  width: 100%;
  padding: var(--space-normal) var(--space-large);
}

.loader {
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  font-size: var(--font-size-large);
  justify-content: center;

  .spinner:before {
    height: 2rem;
    width: 2rem;
    border-left-color: #52acff;
    border-bottom-color: #52acff;
  }
}

</style>
